module.exports = __webpack_public_path__ + "img/daily_rankings.0c113870.png";